// extracted by mini-css-extract-plugin
export default {"LoadingRing":"PhotoGalleryCartLoading-module__LoadingRing__V6r_Y","loadingRing":"PhotoGalleryCartLoading-module__loadingRing__W5KDD"};